export enum PaginationButtonName {
  Next = 'Далее',
  Prev = 'Назад'
}
